export function resolvePromoEventDisplayName(input: {
  readonly eventId: string;
  readonly eventNameById?: ReadonlyMap<string, string>;
  readonly storedEventName?: string | null;
  readonly fallbackLabel: string;
}): string {
  if (input.storedEventName != null && input.storedEventName.length > 0) {
    return input.storedEventName;
  }
  const fromMap = input.eventNameById?.get(input.eventId);
  if (fromMap != null && fromMap.length > 0) {
    return fromMap;
  }
  return input.fallbackLabel;
}
